import { useState, useRef } from 'react'
import Header from './components/Header'
import SidePanel from './components/SidePanel'
import TabBar from './components/TabBar'
import DrawingCanvas, { CanvasHandle } from './components/Canvas/DrawingCanvas'
import { EstimateModal } from './components/EstimateModal'
import { DrawingType } from './types/project'

function App() {
  const [currentTab, setCurrentTab] = useState<DrawingType>('plan')
  const [projectName, setProjectName] = useState('新規プロジェクト')
  const [showEstimate, setShowEstimate] = useState(false)
  const [canvasData, setCanvasData] = useState<any>(null)
  const canvasRef = useRef<CanvasHandle>(null)

  const handleAddComponent = (type: string) => {
    canvasRef.current?.addComponent(type)
  }

  const handleSetBackgroundImage = () => {
    const url = prompt('背景画像のURLを入力してください（Google DriveのURL等）:')
    if (url) {
      canvasRef.current?.setBackgroundImage(url)
    }
  }

  const handleShowEstimate = () => {
    const canvas = canvasRef.current?.getCanvas()
    if (canvas) {
      setCanvasData(canvas)
      setShowEstimate(true)
    }
  }

  const handleSave = () => {
    const canvas = canvasRef.current?.getCanvas()
    if (canvas) {
      const json = JSON.stringify(canvas.toJSON(['wireData', 'componentType']))
      localStorage.setItem(`project_${projectName}`, json)
      alert('保存しました！')
    }
  }

  const handleLoad = () => {
    const savedProject = localStorage.getItem(`project_${projectName}`)
    if (savedProject) {
      const canvas = canvasRef.current?.getCanvas()
      if (canvas) {
        canvas.loadFromJSON(savedProject, () => {
          canvas.renderAll()
          alert('読み込みました！')
        })
      }
    } else {
      alert('保存されたプロジェクトが見つかりません')
    }
  }

  return (
    <div className="flex flex-col h-screen w-full bg-gray-50">
      {/* ヘッダー */}
      <Header 
        projectName={projectName} 
        onProjectNameChange={setProjectName}
        onSetBackgroundImage={handleSetBackgroundImage}
        onSave={handleSave}
        onLoad={handleLoad}
      />

      {/* メインコンテンツ */}
      <div className="flex flex-1 overflow-hidden">
        {/* サイドパネル */}
        <SidePanel 
          currentTab={currentTab} 
          onAddComponent={handleAddComponent}
          onShowEstimate={handleShowEstimate}
        />

        {/* 右側: タブバー + Canvas */}
        <div className="flex-1 flex flex-col">
          {/* タブバー */}
          <TabBar 
            currentTab={currentTab} 
            onTabChange={setCurrentTab} 
          />

          {/* Canvas描画エリア */}
          <DrawingCanvas ref={canvasRef} currentTab={currentTab} />
        </div>
      </div>

      {/* 見積もりモーダル */}
      {showEstimate && (
        <EstimateModal 
          canvasData={canvasData} 
          onClose={() => setShowEstimate(false)}
        />
      )}
    </div>
  )
}

export default App
